const PIXEL_ID = '1705144907338599'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      loaded?: boolean
      version?: string
      push?: unknown
    }
    _fbq?: unknown
  }
}

let initialized = false

export function initPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (initialized) return

  try {
    initialized = true

    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod(...args)
        } else {
          fbq.queue?.push(args)
        }
      } as Window['fbq']

      fbq.queue = []
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.push = fbq

      window.fbq = fbq
      window._fbq = fbq

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'

      const firstScript = document.getElementsByTagName('script')[0]

      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript)
      } else if (document.head) {
        document.head.appendChild(script)
      } else if (document.body) {
        document.body.appendChild(script)
      } else {
        document.documentElement.appendChild(script)
      }
    }

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch (error) {
    console.warn('Meta Pixel failed to initialize:', error)
  }
}

export function trackAddToCart(): void {
  if (typeof window === 'undefined') return

  try {
    if (!initialized) initPixel()
    window.fbq?.('track', 'AddToCart')
  } catch (error) {
    console.warn('Meta Pixel AddToCart failed:', error)
  }
}